module.exports = {"items":[{"layouts":[{"isFirstChoice":true,"placeholders":[{"left":0,"top":0,"width":0,"height":0}]}]}]}


//////////////////
// WEBPACK FOOTER
// ./src/config/templates/layouts/default.json
// module id = 969
// module chunks = 0